import store from '@/store'

export default async () => {
    await store.dispatch('vstup/vstupBootstrap')
}
